module.exports = __webpack_public_path__ + "static/media/children-play-city-elements-svgrepo-com.f6917bd5.svg";